module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-purchase/landpurchase-grid/landpurchase-grid.component.css
// module id = ./src/app/landprocurement/land-purchase/landpurchase-grid/landpurchase-grid.component.css
// module chunks = main